<template>
  <div class="fee-receipt-table mx-8 my-4">
    <table style="width: 100%;" class="table" v-if="receipt">
      <tbody>
        <tr style="height: 22px;">
          <td
            class="border-right-none"
            style="height: 44px;padding-left:20px;"
            colspan="2"
            rowspan="2"
          >
            <img :src="currentInstitution.logo" height="100px" width="100px" />
          </td>
          <td class="border-bottom-none border-sides-none" colspan="8">
            <span class="text-decoration-underline">Refund Receipt (2020-2021)</span>
          </td>
          <td class="border-left-none" style="height: 44px;" colspan="2" rowspan="2">{{copyName}}</td>
        </tr>
        <tr style="height: 22px;">
          <td class="bold border-top-none border-sides-none" style="height: 22px; font-size: 24px;" colspan="8">{{ currentInstitution.name }}</td>
        </tr>
        <tr style="height: 22px;">
          <td class="border-none" style="height: 30px;" colspan="2">Student Name :</td>
          <td
            class="border-none text-left bold"
            style="height: 30px;"
            colspan="4"
          >{{ receipt.fee_account.student.full_name }}</td>
          <td class="border-none" style="height: 30px;" colspan="2">Receipt Number :</td>
          
          <td
            class="border-none text-left bold"
            style="height: 30px;"
            colspan="4"
          >{{ receipt.receipt_number }}</td>
        </tr>
        <tr style="height: 22px;">
          <td class="border-none" style="height: 30px;" colspan="2">Roll Number :</td>
          <td
            class="border-none text-left bold"
            style="height: 30px;"
            colspan="4"
          >{{ receipt.fee_account.student.roll_number }}</td>
          <td class="border-none" style="height: 30px;" colspan="2">Date :</td>
          <td
            class="border-none text-left bold"
            style="height: 30px;"
            colspan="4"
          >{{ moment(receipt.payment_date).format("DD-MMM-YYYY") }}</td>
          
        </tr>
        <tr style="height: 22px;">
          <td class="border-none" style="height: 30px;" colspan="2">Student Category :</td>
          <td
            class="border-none text-left bold"
            style="height: 30px;"
            colspan="4"
          >{{ receipt.fee_account.category?  receipt.fee_account.category.code: "-"}}</td>
        <td class="border-none" style="height: 30px;" colspan="2">Class :</td>
          <td
            class="border-none text-left bold"
            style="height: 30px;"
            colspan="4"
          >{{ receipt.fee_account.room.sections }}</td>

        </tr>
        <tr style="height: 30px;">
          <th style="height: 30px;" colspan="1">Sr. No</th>
          <th style="height: 30px;" colspan="8">Particulars</th>
          <th style="height: 30px;" colspan="2">Amount Paid</th>
        </tr>
        <tr
          style="height: 30px;"
        >
          <td style="height: 30px;" colspan="1"> 1</td>
          <td
            style="height: 30px;"
            colspan="8"
          >Refund</td>

          <td colspan="2">
              {{ currencyFormat(receipt.total_amount) }}
          </td>
        </tr>
        <tr style="height: 30px;">
          <td style="height: 30px;" colspan="1">&nbsp;</td>
          <td style="height: 30px;" class="bold" colspan="8">Total</td>
          <td
            class="bold"
            style="height: 30px;"
            colspan="2"
          >{{ currencyFormat(receipt.total_amount) }}</td>
        </tr>
        <tr style="height: 30px;">
          <td colspan="1" class="bold">Amount in words</td>
          <td colspan="10" class="text-left px-4">{{ inWords(parseInt(receipt.total_amount)).toUpperCase() }}</td>
        </tr>
        <tr style="height: 30px;">
          <td colspan="1" class="bold">Mode</td>
          <td colspan="4">-</td>
          <td colspan="2" class="bold">Remarks</td>
          <td colspan="5" class="text-left px-4">{{ receipt.remarks || "-"  }}</td>
        </tr>

        <tr style="height: 80px">
          <td colspan="10" class="text-left px-4">
            Note: {{receipt.notes || ""}}
          </td>
          <td colspan="2" style="vertical-align: bottom;">
            <b>Cashier/Manager</b>
          </td>
        </tr>


      </tbody>
    </table>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Helper from "@utils/misc";
import moment from "moment";

export default {
  name: "FeeRefundTable",
  props: ["receipt", "copyName"],
  data() {
    return {
      moment: moment,
    };
  },
  computed: {
    ...mapGetters([
      "currentUser",
      "currentInstitution",
      "accessToken",
      "isLoading",
    ]),
    essentials() {
      return {
        accessToken: this.accessToken,
        setLoading: this.setLoading,
        handleErrorsFunction: this.handleApiErrors,
      };
    },
  },
  methods: {
    ...mapActions(["setLoading"]),
    currencyFormat: Helper.currencyFormat,
    inWords: Helper.inWords,
  },
};
</script>

<style lang="css" scoped>
.bold {
  font-weight: bold;
}
table,
th,
td {
  border: 1px solid black;
  border-collapse: collapse;
}
.border-bottom-none {
  border-bottom: none;
}
.border-top-none {
  border-top: none;
}
.border-edges-none {
  border-top: none;
  border-bottom: none;
}
.border-left-none {
  border-left: none;
}
.border-right-none {
  border-right: none;
}
.border-sides-none {
  border-left: none;
  border-right: none;
}
.border-none {
  border: none;
}
</style>